export default __webpack_public_path__ + "static/media/13new.694a2087.jpeg";